import { styled, Box, ButtonBase, Grid, Select } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';

export const Container = styled(Box)({
  height: 'auto',
  marginTop: '64px',
  padding: '30px 50px 30px 10px ',
});

export const Wrapper = styled(Box)({
  margin: '20px 20px 7px 20px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export const StyledButton = styled(ButtonBase)({
  lineHeight: '20px',
  fontWeight: '700',
  fontFamily: 'Lato, sans-serif',
  height: '46px',
  paddingInline: '10px',
  marginLeft: '10px',
  textTransform: 'uppercase',
  gap: '10px',
  boxShadow: '0px 8px 16px rgba(143, 149, 178, 0.15)',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  background: ColorsV2.secondary,
  color: 'white',
  ':hover': {
    background: ColorsV2.acent,
    cursor: 'pointer',
  },
});

export const StyledContainer = styled(Box)({
  border: `1px solid ${ColorsV2.white}`,
  background: ColorsV2.secondary,
  borderRadius: '0px',
  padding: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
});

export const FindingChildGrid = styled(Grid)({
  background: ColorsV2.primary,
  color: 'white',
  fontFamily: 'DM Sans,sans-serif',
  padding: '14px',
  boxSizing: 'border-box',
});
export const CustomSelect = styled(Select)({
  width: '4.1rem',
  height: '1.7rem',
  marginLeft: '10px',
  background: 'transparent',
  fontSize: '0.7em',
  color: ColorsV2.white,
  '& .MuiSvgIcon-root': { color: ColorsV2.white, fontSize: '1.2em' },
  border: `1px solid ${ColorsV2.outline}`,
  '.MuiOutlinedInput-notchedOutline': { border: 'none' },
  '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
});
